<template>
  <div class="material repeating-fields mt-3">
    <CRow>
      <CCol><h5 class="font-weight-bold" style="font-size: 1rem;">Arbeitszeit</h5></CCol>
    </CRow>
    <CRow class="labels" style="margin-left: 1rem;">
      <CCol class="d-none d-md-block col-md-2">
        Datum
      </CCol>
      <CCol class="d-none d-md-block col-md-2">
       Dauer
      </CCol>
      <CCol class="d-none d-md-block col-md-4">
        Mitarbeiter
      </CCol>
      <CCol class="d-none d-md-block col-md-4">
        Tätigkeit
      </CCol>
    </CRow>
    <VueRepeaterLocal v-model="arbeitszeiten" identifier="formular-arbeitszeit"/>
    <CRow>
      <CCol class="col-3"><h5 class="font-weight-bold" style="font-size: 1rem;"></h5></CCol>
      <CCol class="col-9 px-3 py-2 right text-right">
        <CButton
          color="success"
          size="sm"
          class="right text-right"
          @click="addEntry()"
          v-c-tooltip="{content: 'Hinzufügen', placement:'left'}"
        >
          Arbeitszeit hinzufügen
          <CIcon name="cil-library-add"/>
        </CButton>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { EventBus } from '@/helpers/eventBus'
import VueRepeaterLocal from '@/components/VueRepeater/VueRepeaterLocal'

export default {
  name: 'ProtokollArbeitszeit',
  components: {
    VueRepeaterLocal
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    zukuenftigBerechnen: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      arbeitszeiten: [
        {
          name: 'formular-arbeitszeit',
          value: {}
        }
      ],
      doEmit: true
    }
  },
  mounted () {
    this.syncFromProps()
  },
  methods: {
    addEntry: function () {
      EventBus.$emit('addRowArbeitszeit', 'formular-arbeitszeit')
    },
    createRow: function (value = {}) {
      return {
        name: 'formular-arbeitszeit',
        value: value
      }
    },
    emitArbeitszeiten: function () {
      const results = []
      this._.forEach(this.arbeitszeiten, function (zt) {
        if (zt.value) {
          results.push(zt.value)
        }
      })
      this.$emit('input', results)
    },
    syncFromProps: function () {
      const nextRows = []

      if (this.value && this.value.length > 0) {
        this._.forEach(this.value, function (arbeitszeit) {
          if (!arbeitszeit.auto) {
            nextRows.push({
              name: 'formular-arbeitszeit',
              value: arbeitszeit
            })
          }
        })
      }

      if (nextRows.length === 0) {
        nextRows.push(this.createRow())
      }

      if (this.zukuenftigBerechnen && this.zukuenftigBerechnen.length > 0) {
        this._.forEach(this.zukuenftigBerechnen, function (arbeitszeit) {
          nextRows.push({
            name: 'formular-arbeitszeit',
            value: arbeitszeit
          })
        })
      }

      this.doEmit = false
      this.arbeitszeiten = nextRows
      this.doEmit = true
      this.emitArbeitszeiten()
    }
  },
  watch: {
    zukuenftigBerechnen: {
      deep: true,
      handler: function () {
        this.syncFromProps()
      }
    },
    arbeitszeiten: function () {
      if (this.doEmit) {
        this.emitArbeitszeiten()
      }
    }
  }
}
</script>
